<!-- Datos de diseño (ui-redesign): KPI tiles — lectura (valor+unidad+etiqueta) /
     edición (campo .ds en el mismo tile). Visibilidad por tipo de instalación
     data-driven vía parent.isInstFieldVisible(...). -->
<div class="cards">
  <div class="card">
    <div class="sec-head">
      <span class="sec-tile blue"><mat-icon>layers</mat-icon></span>
      <div>
        <h3>{{ "centro.centroData.designData" | translate }}</h3>
        <p>{{ "centro.detail.designSub" | translate }}</p>
      </div>
    </div>

    <form [formGroup]="myDesignForm" *ngIf="hasAnyField; else sinParametros">
      <div class="kt-grid">
        <!-- Alcance del proyecto -->
        <div class="kt" *ngIf="parent.isInstFieldVisible('alcanceProyecto')" [class.is-empty]="!editing && !has('alcancePryID')">
          <span class="kt-ic"><mat-icon>flag</mat-icon></span>
          <div class="kt-body" *ngIf="!editing">
            <div class="kt-v is-text">{{ alcanceCodigo ? (("centro.reachTypes." + alcanceCodigo) | translate) : "—" }}</div>
            <div class="kt-l">{{ "centro.kpi.alcance" | translate }}</div>
          </div>
          <div class="kt-body kt-edit" *ngIf="editing">
            <div class="ff-field">
              <label>{{ "centro.kpi.alcance" | translate }}</label>
              <app-ds-select formControlName="alcancePryID" [options]="tipoAlcanceList" [optionLabel]="alcanceLabelOf"></app-ds-select>
            </div>
          </div>
        </div>

        <!-- Caudal de diseño -->
        <div class="kt" *ngIf="parent.isInstFieldVisible('caudalDiseno')" [class.is-empty]="!editing && !has('caudalDiseno')">
          <span class="kt-ic"><mat-icon>waves</mat-icon></span>
          <div class="kt-body" *ngIf="!editing">
            <div class="kt-v">{{ fmt("caudalDiseno") }}<span class="kt-u" *ngIf="has('caudalDiseno')">m³/día</span></div>
            <div class="kt-l">{{ "centro.kpi.caudalDiseno" | translate }}</div>
          </div>
          <div class="kt-body kt-edit" *ngIf="editing">
            <div class="ff-field">
              <label>{{ "centro.kpi.caudalDiseno" | translate }}<span class="kt-u">m³/día</span></label>
              <div class="ff-box"><input type="number" formControlName="caudalDiseno" noDecimalNumber /></div>
            </div>
          </div>
        </div>

        <!-- Nº de abonados -->
        <div class="kt" *ngIf="parent.isInstFieldVisible('numAbonados')" [class.is-empty]="!editing && !has('numeroAbonados')">
          <span class="kt-ic"><mat-icon>people</mat-icon></span>
          <div class="kt-body" *ngIf="!editing">
            <div class="kt-v">{{ fmt("numeroAbonados") }}</div>
            <div class="kt-l">{{ "centro.kpi.numAbonados" | translate }}</div>
          </div>
          <div class="kt-body kt-edit" *ngIf="editing">
            <div class="ff-field">
              <label>{{ "centro.kpi.numAbonados" | translate }}</label>
              <div class="ff-box"><input type="number" formControlName="numeroAbonados" noDecimalNumber /></div>
            </div>
          </div>
        </div>

        <!-- Habitantes equivalentes -->
        <div class="kt" *ngIf="parent.isInstFieldVisible('habitantesEquivalentes')" [class.is-empty]="!editing && !has('habitantesEquivalentes')">
          <span class="kt-ic"><mat-icon>groups</mat-icon></span>
          <div class="kt-body" *ngIf="!editing">
            <div class="kt-v">{{ fmt("habitantesEquivalentes") }}<span class="kt-u" *ngIf="has('habitantesEquivalentes')">h-e</span></div>
            <div class="kt-l">{{ "centro.kpi.habitantesEq" | translate }}</div>
          </div>
          <div class="kt-body kt-edit" *ngIf="editing">
            <div class="ff-field">
              <label>{{ "centro.kpi.habitantesEq" | translate }}<span class="kt-u">h-e</span></label>
              <div class="ff-box"><input type="number" formControlName="habitantesEquivalentes" noDecimalNumber /></div>
            </div>
          </div>
        </div>

        <!-- Km red de abastecimiento -->
        <div class="kt" *ngIf="parent.isInstFieldVisible('kmRedAbas')" [class.is-empty]="!editing && !has('kmRedAbas')">
          <span class="kt-ic"><mat-icon>route</mat-icon></span>
          <div class="kt-body" *ngIf="!editing">
            <div class="kt-v">{{ fmt("kmRedAbas") }}<span class="kt-u" *ngIf="has('kmRedAbas')">km</span></div>
            <div class="kt-l">{{ "centro.kpi.kmRedAbas" | translate }}</div>
          </div>
          <div class="kt-body kt-edit" *ngIf="editing">
            <div class="ff-field">
              <label>{{ "centro.kpi.kmRedAbas" | translate }}<span class="kt-u">km</span></label>
              <div class="ff-box"><input type="number" formControlName="kmRedAbas" noDecimalNumber /></div>
            </div>
          </div>
        </div>

        <!-- Km red de saneamiento -->
        <div class="kt" *ngIf="parent.isInstFieldVisible('kmRedSanea')" [class.is-empty]="!editing && !has('kmRedSanea')">
          <span class="kt-ic"><mat-icon>alt_route</mat-icon></span>
          <div class="kt-body" *ngIf="!editing">
            <div class="kt-v">{{ fmt("kmRedSanea") }}<span class="kt-u" *ngIf="has('kmRedSanea')">km</span></div>
            <div class="kt-l">{{ "centro.kpi.kmRedSanea" | translate }}</div>
          </div>
          <div class="kt-body kt-edit" *ngIf="editing">
            <div class="ff-field">
              <label>{{ "centro.kpi.kmRedSanea" | translate }}<span class="kt-u">km</span></label>
              <div class="ff-box"><input type="number" formControlName="kmRedSanea" twoDecimalNumber /></div>
            </div>
          </div>
        </div>
      </div>
    </form>

    <ng-template #sinParametros>
      <div class="kt-none">
        <mat-icon>layers_clear</mat-icon>
        <span>{{ "centro.kpi.sinDiseno" | translate }}</span>
      </div>
    </ng-template>
  </div>
</div>
